import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useHead } from '@unhead/vue'

export const useGoogleTagManagerStore = defineStore('googleTagManager', () => {
  const isInitialized = ref(false)
  const id = ref('')

  function init() {
    if (isInitialized.value) return

    const origin = window.location.origin
    const domain_my = import.meta.env.VITE_DOMAIN_MY

    id.value =
      origin == domain_my
        ? import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID_MY
        : import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID_TICKETS

    const script = `<!-- Google Tag Manager -->
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${id.value}');
        <!-- End Google Tag Manager -->`

    useHead({ script: [{ innerHTML: script }] })

    isInitialized.value = true
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  function event(name: string) {
    if (isInitialized.value && (window as any).dataLayer) {
      // eslint-disable-next-line no-extra-semi
      ;(window as any).dataLayer.push({ event: name })
    }
  }
  /* eslint-enable @typescript-eslint/no-explicit-any */

  return { init, event }
})
